var headerWrapper = document.querySelector('body .header-wrapper');
if (headerWrapper) {
    var throttleTimer_1 = null;
    var throttle = function (callback, delay) {
        return function () {
            if (throttleTimer_1)
                return;
            throttleTimer_1 = window.setTimeout(function () {
                callback();
                throttleTimer_1 = null;
            }, delay);
        };
    };
    window.addEventListener('scroll', throttle(function () {
        if (window.scrollY > 0) {
            headerWrapper.classList.add('bg-white');
        }
        else {
            headerWrapper.classList.remove('bg-white');
        }
    }, 100));
}
